// store.js

import { legacy_createStore } from 'redux';
import projectFilterOptionsReducer from './reducer';

const store = legacy_createStore(projectFilterOptionsReducer);

export default store;
